import OptionsInput from "../Components/Inputs/OptionsInput";
import PhoneNumberInput from "../Components/Inputs/PhoneNumberInput";
import SelectInput from "../Components/Inputs/SelectInput";
import TextAreaInput from "../Components/Inputs/TextAreaInput";
import TextInput from "../Components/Inputs/TextInput";

const handleInputChange = (setForm, index, value) => {
  return setForm((prev) => {
    const formData = [...prev];
    formData[index].value = value;
    return formData;
  });
};
const handleCardNoChange = (setForm, index, value) => {
  return setForm((prev) => {
    const formData = [...prev];

    // Remove all non-numeric characters
    let cleanedValue = value.replace(/\D/g, "");

    // Format as "1234 5678 9012 3456"
    let formattedValue = cleanedValue.replace(/(\d{4})/g, "$1 ").trim(); // Adds a space every 4 digits

    formData[index].value = formattedValue;
    return formData;
  });
};
const handleNumericChange = (setForm, index, value) => {
  return setForm((prev) => {
    const formData = [...prev];

    // Remove all non-numeric characters
    let cleanedValue = value.replace(/\D/g, "");
    formData[index].value = cleanedValue;
    return formData;
  });
};
const handleCardExpiryDateChange = (setForm, index, value) => {
  return setForm((prev) => {
    const formData = [...prev];

    // Remove all non-numeric characters
    let cleanedValue = value.replace(/\D/g, "");

    // Format as "MM/YY"
    if (cleanedValue.length > 2) {
      cleanedValue = cleanedValue.slice(0, 2) + "/" + cleanedValue.slice(2, 4);
    }

    // Ensure max length of "MM/YY"
    if (cleanedValue.length > 5) {
      cleanedValue = cleanedValue.slice(0, 5);
    }

    formData[index].value = cleanedValue;
    return formData;
  });
};
const handleValidation = (setForm, properties, index) => {
  return setForm((prev) => {
    const formData = [...prev];
    formData[index].errors = validateInput(properties);
    return formData;
  });
};
const handleContactPreference = (setForm, index, value) => {
  setForm((prev) => {
    const formData = [...prev];
    formData[index].value = value;
    if (value === "Email") {
      formData.find(({ label }) => label === value).required = true;
      formData.find(({ label }) => label === "Phone number").required = false;
    }
    if (value === "Phone") {
      formData.find(({ label }) => label === "Phone number").required = true;
      formData.find(({ label }) => label === "Email").required = false;
    }
    if (value === "No preference") {
      formData.find(({ label }) => label === "Email").required = true;
      formData.find(({ label }) => label === "Phone number").required = true;
    }
    return formData;
  });
};
const handlePasswordValidation = (setForm, validator, properties, index) => {
  return setForm((prev) => {
    const formData = [...prev];
    formData[index].errors = validator(properties).some((x) => x);
    formData[index].passwordErrors = [...validator(properties)];
    return formData;
  });
};
export const inputChangehandlers = {
  handleInputChange,
  handleValidation,
  handleContactPreference,
  handlePasswordValidation,
  handleCardNoChange,
  handleNumericChange,
  handleCardExpiryDateChange,
  //   handleOptionsValidation,
  // Add other handlers as needed
};

const revalidateInput = (formData) => {
  return formData.map((item) => {
    if (item.errors !== null) return item;

    const error = validateInput(item);
    return { ...item, errors: error };
  });
};
const validateForm = (formData) => {
  return formData.reduce((acc, item, index) => {
    const { type, required, value, errors } = item;
    if (errors === null) {
    }
    if (
      type !== "file" &&
      required &&
      (value === null || value === undefined || value === "") &&
      value !== 0
    ) {
      item.errors = "Value is required";
      item.index = index; // Store index for reference
      acc.push(item); // Add to the accumulator
    } else if (errors) {
      acc.push(item); // Include if there are existing errors
    }
    return acc; // Return accumulated results
  }, []);
};
const convertContactForm = (formData) => {
  return formData.reduce((acc, item) => {
    if (item.value) {
      // Check if the value is not empty
      acc[item.name] = item.value;
    }
    return acc;
  }, {});
};
export const processFormData = (formData) => {
  console.log("processFormData", formData);
  const revalidateFormData = revalidateInput(formData);
  // console.log("revalidateFormData",revalidateFormData)

  const formErrors = validateForm(revalidateFormData);
  // console.log("formErrors",formErrors)
  if (formErrors.length > 0) {
    return { errors: true, formErrors };
  }

  const convertedForm = convertContactForm(formData);
  return convertedForm;
};

export const getPhoneNoFormComp = (
  selectProps,
  txtProps,
  setForm,
  selectIndex,
  txtIndex
) => {
  // console.log("selectProps",selectProps)
  return (
    <PhoneNumberInput
      setForm={setForm}
      selectProps={selectProps}
      cntryCodeIndex={selectIndex}
      txtProps={txtProps}
      phoneNoIndex={txtIndex}
    />
  );
};

export const getFormComponent = ({ props, setForm, index }) => {
  // console.log("props",props)
  const type = props.inputType;

  const sharedProps = {
    key: index,
    properties: props,
    index,
    setForm,
  };

  const componentsMap = {
    TextInput: <TextInput {...sharedProps} />,
    SelectInput: <SelectInput {...sharedProps} />,
    OptionsInput: <OptionsInput {...sharedProps} />,
    TextArea: <TextAreaInput {...sharedProps} />,
  };

  return componentsMap[type] || null;
};

export const validateInput = (properties) => {
  console.log("validateInput called");

  let {
    name,
    label = "Field",
    value,
    required,
    type,
    inputMode,
    validator,
    integer = false,
    minLength,
    maxLength,
    min,
    max,
  } = properties;

  if (typeof value === "string") {
    value = value.trim();
  }

  if (required && !value) {
    return `${label} is required.`;
  }

  // Default to text validation
  if (!type || type === "text") {
    if (minLength && value.length < minLength) {
      return `${label} must be at least ${minLength} characters.`;
    }
    if (maxLength && value.length > maxLength) {
      return `${label} must be at most ${maxLength} characters.`;
    }

    // Rule definitions
    const regexSets = {
      textValidator: [
        {
          condition: (val) => val.length < 3,
          message: "Message must be at least 3 characters long.",
        },
        {
          regex: /^[\w\s.,!?'"@%&()\-+=:;#/\\]*$/,
          message: "Message contains invalid characters.",
        },
        {
          condition: (val) => /[\u{1F600}-\u{1F6FF}]/u.test(val),
          message: "Please avoid using emojis.",
        },
      ],
      numericCodeValidator: [
        {
          regex: /^\d+$/,
          message: `${label} must be numeric.`,
        },
      ],
      nameValidator: [
        {
          condition: (val) => val.startsWith("-") || val.endsWith("-"),
          message: "Name cannot start or end with a hyphen.",
        },
        {
          condition: (val) => val.endsWith(" "),
          message: "Name cannot end with a space.",
        },
        {
          condition: (val) => /\d/.test(val),
          message: "Name cannot contain numbers.",
        },
        {
          condition: (val) => /[^\w\s'-]/.test(val),
          message: "Name contains invalid characters.",
        },
        {
          condition: (val) => (val.match(/[a-zA-Z]/g) || []).length < 2,
          message: "Name must contain at least 2 letters.",
        },
        {
          regex: /^[A-Za-z]+(?:[ '-][A-Za-z]+)*$/,
          message: "Only letters, spaces, apostrophes, or hyphens are allowed.",
        },
      ],
      company_name: [
        {
          condition: (val) => /^[^a-zA-Z0-9]/.test(val),
          message: "Company name cannot start with a symbol or space.",
        },
        {
          condition: (val) => /[&]{2,}/.test(val),
          message: "Company name cannot contain repeated special characters.",
        },
        {
          regex: /[a-zA-Z]{3,}/,
          message: "Must contain at least 3 letters.",
        },
        {
          regex: /^[A-Za-z0-9 '&.,/-]+$/,
          message:
            "Only alphanumeric characters and allowed punctuation are permitted.",
        },
      ],
      registeration_number: [
        {
          condition: (val) => /^-|-$/g.test(val),
          message: "Registration number cannot start or end with a hyphen.",
        },
        {
          condition: (val) => /^[0-9]+$/.test(val),
          message: "Registration number must include letters.",
        },
        {
          regex: /^[a-zA-Z0-9-]+$/,
          message: "Only alphanumeric characters and hyphens are allowed.",
        },
      ],
      address_line: [
        {
          condition: (val) => /^[^a-zA-Z0-9]/.test(val),
          message: "Address cannot start with a symbol.",
        },
        {
          condition: (val) => !/[a-zA-Z0-9]/.test(val), //Address must include at least one letter or number
          message: "Invalid address value.",
        },
        {
          regex: /^[A-Za-z0-9\s#/\\.,'-]+$/,
          message:
            "Only alphanumeric characters and allowed punctuation are permitted.",
        },
      ],
      postcode: [
        {
          condition: (val) => /^[ -]/.test(val),
          message: "Postcode cannot start with a space or hyphen.",
        },
        {
          condition: (val) => /[ -]{2,}/.test(val),
          message: "Postcode cannot contain repeated spaces or hyphens.",
        },
        {
          regex: /^[a-zA-Z0-9\s-]+$/,
          message:
            "Only alphanumeric characters, spaces, and hyphens are allowed.",
        },
      ],
      city: [
        {
          condition: (val) => /[ -]{2,}/.test(val),
          message: "City name cannot have repeated spaces or hyphens.",
        },
        {
          condition: (val) => /[-\s]$/.test(val),
          message: "City name cannot end with a space or hyphen.",
        },
        {
          regex: /^[A-Za-z]+(?:[ .'-][A-Za-z]+)*$/,
          message:
            "Only letters, spaces, apostrophes, hyphens, or dots are allowed.",
        },
      ],
    };

    const resolvedValidator =
      regexSets[validator] ||
      regexSets[name] ||
      (inputMode === "numeric" && regexSets.numericCodeValidator) ||
      regexSets.textValidator;

    for (const rule of resolvedValidator) {
      if (rule.regex && !rule.regex.test(value)) {
        return rule.message;
      }
      if (rule.condition && rule.condition(value)) {
        return rule.message;
      }
    }

    return false;
  }

  // Number validation
  if (type === "number") {
    const numeric = parseFloat(value);
    const isNumeric = /^[+-]?(\d+(\.\d*)?|\.\d+)$/.test(value);

    if (required && !isNumeric) {
      return `Invalid ${label} format.`;
    }

    if (isNumeric) {
      if (integer && !Number.isInteger(numeric)) {
        return `${label} must be an integer.`;
      }
      if (min != null && numeric < min) {
        return `${label} must be at least ${min}.`;
      }
      if (max != null && numeric > max) {
        return `${label} must be at most ${max}.`;
      }
    }

    return false;
  }

  // Email validation
  if (type === "email") {
    const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
    if (!emailRegex.test(value)) {
      return "Invalid email format.";
    }
    return false;
  }

  // Password validation
  if (type === "password") {
    if (value.length < 8) {
      return "Password must be at least 8 characters.";
    }

    const passwordRegex =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&_-])[A-Za-z\d@$!%*?&_-]{8,}$/;

    if (!passwordRegex.test(value)) {
      return "Include uppercase, lowercase, number, and special character.";
    }

    return false;
  }

  // Phone number validation
  if (type === "tel") {
    if (minLength && value.length < minLength) {
      return `${label} must be at least ${minLength} characters.`;
    }

    if (maxLength && value.length > maxLength) {
      return `${label} must be at most ${maxLength} characters.`;
    }

    if (/\D/.test(value)) {
      return "Phone number must contain digits";
    }

    if (!/^[1-9]\d{4,14}$/.test(value)) {
      return "Phone number cannot start with 0.";
    }

    return false;
  }

  return false; // If no validation error
};
